<template>
    <div class="dgth-calendar-controls">
        <div class="inner">
            <div class="left">
                <div class="control">
                    <select @change="onFilterChange($event, 'selectedCourse')" v-model="selectedCourse">
                        <option value="" selected="selected">Izaberite kurs</option>
                        <option v-for="filter in filters.course" :value="filter">{{ filter }}</option>
                    </select>
                </div>
                <div class="control">
                    <select @change="onFilterChange($event, 'selectedYear')" v-model="selectedYear">
                        <option value="" selected="selected">Izaberite godinu</option>
                        <option v-for="filter in filters.year" :value="filter">{{ filter }}</option>
                    </select>
                </div>
                <div class="control">
                    <select @change="onFilterChange($event, 'selectedType')" v-model="selectedType">
                        <option value="" selected="selected">Izaberite tip eventa</option>
                        <option v-for="filter in filters.type" :value="filter">{{ filter }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div v-if="this.loaded && getEvents.length === 0" class="empty-msg">
            <p>*Nema rezultata.</p>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    export default {
        props: ['loaded'],

        created() {
            this.fetchFilters().then(() => {
                this.filters = this.getFilters;
            });
        },
        mounted() {

        },
        data () {
            return {
                filters: [],
                selectedCourse: '',
                selectedYear: '',
                selectedType: '',
            }
        },
        methods: {
            ...mapActions([
                'fetchEventsByFilter',
                'fetchFilters'
            ]),
            onFilterChange(e, stateValue) {
                this[stateValue] = e.target.value;
                const filter = `course=${this.selectedCourse}&year=${this.selectedYear}&type=${this.selectedType}`;

                this.fetchEventsByFilter(filter).then(() => {
                    this.events = this.getEvents;
                });
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedDay',
                'getFilters',
                'getEvents'
            ])
        }
    }
</script>

<style lang="scss">
    .dgth-calendar-controls {
        position: absolute;
        top: 75px; left: 0; right: 0;

        @media (min-width: 768px) {
            top: 90px;
        }

        .inner {
            display: flex;
            flex-direction: column;

            .control {

                &:not(:first-child) {
                    margin-top: 10px;
                }
            }

            .left {
                width: 100%;
            }

            @media (min-width: 768px) {
                flex-direction: row;

                .control {

                    &:not(:first-child) {
                        margin: 0 0 0 10px;
                    }
                }

                .left {
                    display: flex;
                }
            }
        }

        select {
            border-radius: 2px;
            border: 1px solid #f5f5f5;
            background: transparent;
            box-shadow: none;
            padding: 10px;
            max-width: 200px;
            width: 200px;

            @media (min-width: 768px) and (max-width: 992px) {
                width: 150px;
            }

            &.no-border {
                border: 0;
            }
        }

        .empty-msg {
            margin-top: 8px;
            color: #ff7c0d;
            font-weight: 600;

            p {
                margin: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DisplayHeader.vue